// Status options with keys that should be translated using t('status', key)
export const statusOptions = [
    {id: 1, key: "pending"},
    {id: 2, key: "approved"},
    {id: 3, key: "rejected"},
    {id: 4, key: "communicationError"},
    {id: 5, key: "otherProductPurchased"}
]

export const statusArray = ["PENDING", "APPROVED", "REJECTED", "COMMUNICATION_ERROR", "OTHER_PRODUCT_PURCHASED"]

// Helper function to get status key by id
export const getStatusKeyById = (id: number): string => {
    const status = statusOptions.find(s => s.id === id);
    return status ? status.key : "";
}

// Helper function to get status key by array value
export const getStatusKeyByValue = (value: string): string => {
    const index = statusArray.indexOf(value);
    return index !== -1 && statusOptions[index] ? statusOptions[index].key : "";
}